/**
 * @fileoverview 日付ユーティリティ util
 */
'use strict';
// Library Import
import _ from 'lodash';
import moment from 'moment';

/**
 * 日時のフォーマット変換
 *
 * @name UnixTimeToDateString
 * @function
 * @memberOf utils.DateUtil
 * @param {Number} unixTime UnixTime
 * @param {String} tokens 出力フォーマット
 * @return {String} unixTimeを指定フォーマットに変換した文字列
 */
export const UnixTimeToDateString = (unixTime, tokens) => {
  // NaNチェック
  if (_.isNaN(unixTime)) {
    return '';
  }
  // 数値チェック
  if (!_.isNumber(unixTime)) {
    return '';
  }
  // 文字列チェック
  if (!_.isString(tokens)) {
    return '';
  }
  moment.locale('ja');
  return moment(unixTime).format(tokens);
};

/**
 * 日付文字列からDateオブジェクト生成
 *
 * @param {String} dateString 日付文字列
 * @returns {Date} Dateオブジェクト
 */
export const StringToDate = (dateString, tokens) => {
  // 文字列チェック
  if (!_.isString(dateString)) {
    return '';
  }
  moment.locale('ja');
  return moment(dateString, tokens).toDate();
};



// WEBPACK FOOTER //
// ./src/js/util/DateUtil.jsx